export default "__VITE_ASSET__l16Q$tZE__"